import PropTypes from 'prop-types';

const HeroSection = ({
  backgroundImage,
  title,
  subtitle,
  buttons = [],
  overlayOpacity = 0.85,
  textAlign = 'center',
  height = 'h-screen',
}) => {

  const scrollToNext = () => {
    window.scrollBy({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <section
      className={`relative ${height} flex items-center justify-center overflow-hidden`}
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt="Hero background"
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>
        {/* Blue Overlay */}
        <div className="absolute inset-0 primary-bg" style={{ opacity: overlayOpacity }}></div>
      </div>

      {/* Content */}
      <div className="relative z-20 h-full flex items-center justify-center w-full">
        <div className="container mx-auto px-4 md:px-8">
          <div
            className={`max-w-2xl ${
              textAlign === 'center' ? 'mx-auto text-center' : ''
            } ${textAlign === 'left' ? 'text-left' : ''} ${
              textAlign === 'right' ? 'text-right ml-auto' : ''
            }`}
          >
            {/* Title */}
            <h1 className="  font-bold text-white leading-tight mb-4 md:mb-6 fade-in">
              {title}
            </h1>

            {/* Subtitle */}
            {subtitle && (
              <p className="   text-white/90 leading-relaxed mb-8 md:mb-10 max-w-xl mx-auto fade-in">
                {subtitle}
              </p>
            )}

            {/* Buttons */}
            {buttons.length > 0 && (
              <div
                className={`flex flex-col sm:flex-row gap-4 ${
                  textAlign === 'center'
                    ? 'justify-center items-center'
                    : textAlign === 'right'
                    ? 'justify-end items-end'
                    : 'justify-start items-start'
                } fade-in`}
              >
                {buttons.map((button, index) => (
                  <button
                    key={index}
                    onClick={button.onClick}
                    className={`${button.className || 'btn-white'} px-6 py-1 md:px-8 md:py-2   font-semibold rounded-lg transition-all duration-300 w-full sm:w-auto ${
                      button.customClass || ''
                    }`}
                    style={button.style}
                  >
                    {button.icon && <span className="mr-1">{button.icon}</span>}
                    {button.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Scroll Down Arrow */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 z-30 animate-bounce"
        aria-label="Scroll down"
      >
        <svg
          className="w-8 h-8 md:w-10 md:h-10 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </svg>
      </button>
    </section>
  );
};

HeroSection.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      className: PropTypes.string,
      customClass: PropTypes.string,
      icon: PropTypes.node,
      style: PropTypes.object,
    })
  ),
  overlayOpacity: PropTypes.number,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  height: PropTypes.string,
  titleSize: PropTypes.string,
};

export default HeroSection;